// extracted by mini-css-extract-plugin
module.exports = {"theme":"#1890ff","menuBg":"#011528","menuText":"#a6aaae","menuActiveText":"#fff","menuItemHover":"#fff"};